import { Skeleton, SkeletonBox } from 'skullet/react'

import { AppShellFrame } from './app-shell'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '../ui/sidebar'

const NAV_GROUPS = [
  { label: 'Home', items: ['Dashboard', 'Pipeline', 'Leads', 'Quotes', 'Invoices'] },
  { label: 'CRM', items: ['Events', 'Contacts', 'Tasks'] },
  { label: 'Settings', items: ['Company', 'Team'] },
]

/**
 * The authenticated shell drawn as a skeleton while auth and the user load.
 * It shares AppShell's frame and sidebar primitives, so the sidebar column,
 * header strip and content card land where the real shell mounts.
 *
 * The frame itself stays real: wrapped whole, skullet draws the content card
 * as one block and the fixed sidebar as nothing.
 */
export function AppShellSkeleton() {
  return (
    <AppShellFrame sidebar={<SidebarSkeleton />}>
      <Skeleton loading>
        <div className="flex h-12 shrink-0 items-center gap-2 px-4">
          <span className="text-sm">Home / Dashboard</span>
        </div>
      </Skeleton>
      <div className="flex-1" />
    </AppShellFrame>
  )
}

function SidebarSkeleton() {
  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg">
              <SkeletonBox width={36} height={36} radius="0.375rem" />
              <span className="truncate font-semibold">Cortado Pro</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <Skeleton loading label="Loading Cortado">
          {NAV_GROUPS.map((group) => (
            <SidebarGroup key={group.label}>
              <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
              <SidebarMenu>
                {group.items.map((item) => (
                  <SidebarMenuItem key={item}>
                    <SidebarMenuButton>
                      <SkeletonBox width={16} height={16} radius="0.25rem" />
                      <span>{item}</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroup>
          ))}
        </Skeleton>
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg">
              <SkeletonBox width={32} height={32} radius="0.5rem" />
              <Skeleton loading>
                <span className="truncate">Organization name</span>
              </Skeleton>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  )
}
